import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { Ad, AdsApiResponse } from './types';

export const ADS_QUERY_KEY = ['ads'] as const;

/**
 * Katalog reklam. Lista idzie z `v3-getAds` (codebase `admin`, admin SDK), bo
 * kolekcja `ads` jest w regułach zamknięta dla klienta — szczegóły w `types.ts`.
 */
export const fetchAds = async (): Promise<Ad[]> => {
  const res = await axiosInstance.get<AdsApiResponse<Ad[]>>('/v3-getAds');
  const data = res.data?.data;
  // Zimny start funkcji potrafi zwrócić odpowiedź o innym kształcie (np. echo
  // warmupu). Rzucamy błąd zamiast cache'ować pustą listę — react-query ponowi.
  if (!Array.isArray(data)) {
    throw new Error('Nieoczekiwany kształt odpowiedzi /v3-getAds');
  }
  return data;
};

/** Wspólne dla listy i pojedynczej reklamy — obie karmi ten sam wpis w cache. */
export const adsQueryConfig = {
  queryKey: ADS_QUERY_KEY,
  queryFn: fetchAds,
  retry: (failureCount: number, error: AxiosError) => {
    const status = error?.response?.status;
    if (status && status >= 400 && status < 500) return false;
    return failureCount < 3;
  },
  retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 8000),
  refetchOnWindowFocus: false,
};

export const useGetAds = (): UseQueryResult<Ad[], AxiosError> => useQuery<Ad[], AxiosError>(
  adsQueryConfig,
);
